module.exports = __webpack_public_path__ + "static/media/arrow_xl_r.32587c80.svg";